export default __webpack_public_path__ + "static/media/graph.3b5a27d5.svg";